var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useCallback, useState } from 'react';
import Input from '../../../input';
import { useField, useFormikContext } from 'formik';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import FormInput from '../form-input';
import { PasswordVisibilityToggleIcon, PasswordVisibilityToggleIconContainer } from './styles';
import { useFormField } from '../../hooks';
import { useErrorTrackingOnSubmit, useHandleBlur } from '../hooks';
import theme from '../../../../theme';
var PasswordInput = function (_a) {
    var label = _a.label, subtext = _a.subtext, tooltip = _a.tooltip, trackValidationOnBlur = _a.trackValidationOnBlur, trackValidationOnSubmit = _a.trackValidationOnSubmit, restProps = __rest(_a, ["label", "subtext", "tooltip", "trackValidationOnBlur", "trackValidationOnSubmit"]);
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    var field = useField(restProps)[0];
    var validateOnBlur = useFormikContext().validateOnBlur;
    var onBlur = field.onBlur, _c = field.value, value = _c === void 0 ? '' : _c, name = field.name;
    var _d = useFormField(name), error = _d.error, customError = _d.customError, customWarning = _d.customWarning, touched = _d.touched, validateField = _d.validateField;
    var _togglePassword = useCallback(function () {
        setIsPasswordVisible(function (isPasswordVisible) { return value.length > 0 && !isPasswordVisible; });
    }, [value]);
    var _handleBlur = useHandleBlur(onBlur, name, validateField, validateOnBlur, trackValidationOnBlur);
    useErrorTrackingOnSubmit(name, trackValidationOnSubmit);
    return (React.createElement(FormInput, { label: label, subtext: subtext, tooltip: tooltip, name: name, error: error || customError, warning: customWarning, touched: touched },
        React.createElement(Input, __assign({}, field, restProps, { type: isPasswordVisible ? 'text' : 'password', error: error || customError, warning: customWarning, touched: touched, padding: theme.spacing.small, onBlur: _handleBlur }),
            React.createElement(PasswordVisibilityToggleIconContainer, { onClick: _togglePassword },
                React.createElement(PasswordVisibilityToggleIcon, { as: isPasswordVisible ? FaRegEyeSlash : FaRegEye, color: value.length > 0 ? theme.colors.tfwBlack87 : theme.colors.tfwBlack12 })))));
};
export default memo(PasswordInput);
